import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function UpdateProfileRequestList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: "select", sortable: false, label: "Select" },
        { key: "request_by_name", sortable: true, label: "Request By" },
        { key: "status_label", sortable: true, label: "Status" },
        { key: "created_at", sortable: true },
        { key: "actions" }
    ];
    const perPage = ref(10);
    const totalUpdateProfileRequestList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(null);
    const requestedByFilter = ref(null);
    const updateProfileRequestsMetaData = ref([]);
    const updateProfileRequestStatusOption = ref([]);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalUpdateProfileRequestList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch(
        [
            currentPage,
            perPage,
            searchQuery,
            statusFilter,
            requestedByFilter,
            
        ],
        () => {
            refetchData();
        }
    );

    const fetchUpdateProfileRequestList = (ctx, callback) => {
        store
            .dispatch("app-update-profile-requests/fetchUpdateProfileRequests", {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value,
                requestedBy: requestedByFilter.value,
            })
            .then(response => {
                const update_profile_request = response.data.data;
                const { total } = response.data.meta;
                updateProfileRequestStatusOption.value = response.data.status;

                callback(update_profile_request);
                totalUpdateProfileRequestList.value = total;
                updateProfileRequestsMetaData.value = update_profile_request;
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching update profile requests",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });
                toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching update profile requests`,
                      icon:'AlertTriangleIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                        },
                        {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                        })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == 0) return "warning";
        if (status == 1) return "success";
        if (status == 2) return "danger";
        if (status == 3) return "info";
        return "primary";
    };

    return {
        fetchUpdateProfileRequestList,
        tableColumns,
        perPage,
        currentPage,
        totalUpdateProfileRequestList,
        updateProfileRequestsMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        resolveUserStatusVariant,
        updateProfileRequestStatusOption,
        statusFilter,
        requestedByFilter
    };
}
